import type { CfpConfig, FooterConfig } from "@p2l/window-fn-types";

export const globalFooterInit = () => {
  const cfpConfig: CfpConfig = {
    openFeedbackDialog: () => {},
  };

  const footerConfig: FooterConfig = {
    CfpConfig: cfpConfig,
  };

  window.p2lFooterConfig = footerConfig;
};
